import { ContractDeclarationGame } from '../models/contract-declaration-game'
import { ContractDeclarationGameDto } from '../dtos/contract-declaration-game.dto'
import { gamePropsMapper } from './game-props.mapper'
import { Contract } from '../models/contract'

export const contractDeclarationGameMapper = {
  mapToContractDeclarationGame(
    contractDeclarationGameDto: ContractDeclarationGameDto,
  ): ContractDeclarationGame {
    return new ContractDeclarationGame({
      ...contractDeclarationGameDto,
      ...gamePropsMapper.mapToGameProps(contractDeclarationGameDto),
      userContractOptions: contractDeclarationGameDto.userContractOptions.map(
        (option) => new Contract(option),
      ),
    })
  },
}
